import React from 'react';

import H2 from 'apps/Pdf/components/common/H2';

import { sqlDateToLabel, formatAmount } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { useTranslation } from 'react-i18next';
import { FeeMovementsData } from '../StatementInterface';
import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface Props {
  from: string;
  to: string;
  data: FeeMovementsData[];
  total: { base: AmountValue, vat: AmountValue, value: AmountValue };
  currency: Currency;
}

const FeeMovementsTable = (props: Props) => {
  const styles = useGeneralStyles();
  const tables = useTableStyles();
  const { data } = props;
  const { t } = useTranslation();

  return (
    <>
      {data.length ? (
        <>
          <H2>
            Poplatky v období {sqlDateToLabel(props.from, 'd. M. yyyy')}&#8202;—&#8202;
            {sqlDateToLabel(props.to, 'd. M. yyyy')}
          </H2>

          <table className={`${tables.root} ${tables.overview}`}>
            <thead>
              <tr>
                <th>Datum</th>
                <th>Za období</th>
                <th>Typ poplatku</th>
                <th>Částka bez DPH</th>
                <th>DPH</th>
                <th>Částka celkem</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`${item.date}`}>
                  <td>{sqlDateToLabel(item.date, 'd. M. yyyy')}</td>
                  <td className={styles.value}>
                    {item.period && sqlDateToLabel(item.period, 'LLLL yyyy')}
                  </td>
                  <td className={styles.value}>{t(item.type)}</td>
                  <td className={styles.value} align='right'>{formatAmount(item.base || item.value, props.currency)}</td>
                  <td className={styles.value} align='right'>{formatAmount(item.vat || 0, props.currency)}</td>
                  <td className={styles.value}>{formatAmount(item.value, props.currency)}</td>
                </tr>
              ))}
              {props.total && (
                <tr className="sum">
                  <td colSpan={3} className={styles.value}>
                    Celkem
                  </td>
                  <td className={styles.value} align='right'>{formatAmount(props.total.base || props.total.value, props.currency)}</td>
                  <td className={styles.value} align='right'>{formatAmount(props.total.vat || 0, props.currency)}</td>
                  <td className={styles.value}>{formatAmount(props.total.value, props.currency)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  );
};

export default FeeMovementsTable;
